












































































































































































































































































































































































































































































import { mdiPaperclip } from "@mdi/js";
import { mdiDelete } from "@mdi/js";
import { Component, Mixins } from "vue-property-decorator";
import PhoneMask from "@/components/ui/PhoneMask.vue";
import { AppealsModule } from "@/store/appeals.module";
import { translate } from "@/utils";
import { ContractsModule } from "@/store/contracts.module";
import {
  Appeal,
  AppealFile,
  EditAppealDto,
  SaveAttachDTO,
} from "../../../../lib/appeal.type";
import FormValidator from "@/mixins/FormValidator";
import { FileService } from "@/services/file.service";
import { Contract } from "../../../../lib/contract.type";

@Component({ components: { "phone-mask": PhoneMask } })
export default class Appeals extends Mixins(FormValidator) {
  autoGrowHack: boolean = false;

  forceReRender() {
    this.autoGrowHack = !this.autoGrowHack;
  }

  clickEdit() {
    this.isEdit = true;
    this.forceReRender();
  }

  downloadFile(f: AppealFile) {
    AppealsModule.getFile({
      request_attachment_rid: f.request_attachment_rid,
    }).then(() => {
      const byteOffset = 0;
      const b = new Blob([
        new Uint8Array(
          AppealsModule.fileData.attach_file.data,
          byteOffset,
          length,
        ),
      ]);
      FileService.downloadFile(b, f.attach_file_name);
    });
  }

  deleteFile(request_attachment_rid: number) {
    AppealsModule.deleteFile({
      request_attachment_rid: request_attachment_rid,
    }).then(() => {
      this.reloadFileList();
    });
  }

  reloadFileList() {
    const rid = this.isNew
      ? this.newApp.request_id
      : this.appealHeader
      ? this.appealHeader.request_rid
      : 0;

    AppealsModule.getFiles({
      iRequestRid: rid,
      data: null as any,
      IsAes: 0,
    });
    AppealsModule.getFilesAes({
      iRequestRid: rid,
      data: null as any,
      IsAes: 1,
    });
  }

  get fileList() {
    return AppealsModule.fileList;
  }

  get fileListAES() {
    return AppealsModule.fileListAES;
  }

  onDragEnter() {
    this.isDragging = true;
  }

  $refs: {
    fileInputRef: any;
  };

  onFileChooserClick() {
    this.$refs.fileInputRef.click();
  }

  async fileInputHandler(e: any) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    if (file.size <= 50 * 1024 * 1024) {
      const req: SaveAttachDTO = new SaveAttachDTO();
      req.iRequestRid = this.isNew
        ? this.newApp.request_id
        : this.appealHeader
        ? this.appealHeader?.request_rid
        : 0;
      const formData = new FormData();
      formData.append("file", file);
      req.data = formData;
      AppealsModule.saveAttach(req).then(() => {
        this.reloadFileList();
      });
    }
  }

  formRef = "formAppeal";
  isEdit: boolean = false;

  async saveAppealCancel() {
    this.saveAppeal("state_canceled");
  }

  async saveAppealConsidering() {
    this.saveAppeal("state_considering");
  }

  async saveAppealDraft() {
    this.saveAppeal("state_draft");
  }

  async saveAppeal(type: string) {
    if (!this.validateForm()) {
      return;
    }
    const saveData = new EditAppealDto();
    saveData.iRequestRid = this.isNew
      ? this.newApp.request_id
      : this.appealHeader
      ? this.appealHeader.request_rid
      : 0;
    saveData.nvcRequestStateCodeName = type;
    saveData.nvcContactPerson = this.contactPerson;
    saveData.nvcEmail = this.email;
    saveData.fContactPhoneNumber = this.phone;
    saveData.iRequestTypeRid = this.themeRid;
    saveData.iContractRid = this.contractRid;
    saveData.nvcRequestDescription = this.description;
    this.buttonsEnable = false;
    AppealsModule.editAppeal(saveData).then(() => {
      this.buttonsEnable = true;
      this.$router.back();
    });
  }

  //   validateForm() {
  //     return (this.$refs[this.formRef] as Vue & {
  //       validate: () => boolean;
  //     }).validate();
  //   }

  saveClick() {
    this.validateForm();
  }

  get isLoading(): boolean {
    return false;
  }

  get isNew(): boolean {
    return this.$route.params.RequestId === undefined;
  }

  get appealHeader(): Appeal | undefined {
    const appeal = AppealsModule.appealList.find(
      x => x.request_rid.toString() == this.$route.params.RequestId,
    );
    return translate(appeal);
  }

  buttonsEnable: boolean = true;
  appealNumber: string = null as any;
  statusRid: number = null as any;
  themeRid: number = null as any;
  contractRid: number = null as any;
  contactPerson: string = null as any;
  email: string = null as any;
  phone: string = null as any;
  description: string = null as any;
  DateCreate: Date = null as any;
  DateSend: Date = null as any;
  isDragging: boolean = false;

  get showDateSend(): boolean {
    return this.checkExistsStatus([
      "state_executed",
      "state_canceled",
      "state_considering",
    ]);
  }

  get showResponse(): boolean {
    return this.checkExistsStatus(["state_executed"]);
  }

  get showEditButton(): boolean {
    return this.checkExistsStatus(["state_draft"]);
  }

  get showCloseButton(): boolean {
    return this.checkExistsStatus([
      "state_executed",
      "state_canceled",
      "state_considering",
    ]);
  }

  checkExistsStatus(statuses: string[]) {
    if (this.appealHeader) {
      const ix = statuses.findIndex(
        c => c == this.appealHeader?.request_status_code_name.toLowerCase(),
      );
      if (ix >= 0) {
        return true;
      } else return false;
    } else return false;
  }

  get appealTypeList() {
    return translate(AppealsModule.appealTypeList);
  }

  get appealStatusList() {
    return translate(AppealsModule.appealStatusList);
  }

  get getStatusName() {
    const st = this.appealStatusList.find(x => x.record_id == this.statusRid);
    if (st) {
      return (st as any).request_state_name;
    } else return "";
  }

  get contracts() {
    const x: Contract[] = [];
    const c = new Contract();
    c.contract_rid = null as any;
    c.contract_number = this.$t("appeals.all").toString();
    x.push(c);
    ContractsModule.contracts.forEach(element => {
      const c2 = new Contract();
      c2.contract_rid = element.contract_rid;
      c2.contract_number = element.contract_number;
      x.push(c2);
    });
    return x;
  }

  get newApp() {
    return AppealsModule.newApp;
  }

  async mounted() {
    AppealsModule.clearFileList();
    this.buttonsEnable = true;
    this.isEdit = false;
    this.reloadFileList();
    if (this.isNew) {
      AppealsModule.getNewAppeal();
      const s = this.appealStatusList.find(c => c.code_name == "state_draft");
      if (s) {
        this.statusRid = s.record_id;
      } else {
        this.$router.back();
        return;
      }
      this.themeRid = null as any;
      this.contractRid = null as any;
      this.email = null as any;
      this.phone = null as any;
      this.description = null as any;
      this.contactPerson = null as any;
      this.appealNumber = null as any;
    } else {
      if (this.appealHeader) {
        this.DateCreate = this.appealHeader.request_date;
        this.DateSend = this.appealHeader.request_send_date;
        this.statusRid = this.appealHeader.request_state_rid;
        this.themeRid = this.appealHeader.request_type_rid;
        this.contractRid = this.appealHeader.contract_rid;
        this.email = this.appealHeader.email;
        this.phone = this.appealHeader.contact_phone_number;
        this.description = this.appealHeader.request_description;
        this.contactPerson = this.appealHeader.contact_person;
        this.appealNumber = this.appealHeader.request_number.toString();
      } else {
        this.$router.back();
        return;
      }
    }
  }
}
